const modes = [
  {
    "Sales Transaction": [
      {
        title: "Cash Sales",
        url: "/admin/transaction/Cash-Sales",
      },
      {
        title: "Customer Order",
        url: "/admin/transaction/Customer-Order",
      },
      {
        title: "Sales Invoice",
        url: "/admin/transaction/Sales-Invoice",
      },
      {
        title: "Sales Debit Note",
        url: "/admin/transaction/Sales-Debit-Note",
      },
      {
        title: "Sales Credit Note",
        url: "/admin/transaction/Sales-Credit-Note",
      },
    ],
  },
  {
    "Stock Transactions": [
      {
        title: "Good Received Note(GRN)",
        url: "/admin/transaction/Good-Received-Note",
      },
      {
        title: "Cash Purchase",
        url: "/admin/transaction/Cash-Purchase",
      },
      {
        title: "Stock Adjustment File",
        url: "/admin/transaction/Stock-Adjustment-File",
      },
      {
        title: "Inter Store Transfer",
        url: "/admin/transaction/Inter-Store-Transfer",
      },
      {
        title: "Serial No. Log File",
        url: "/admin/transaction/Serial-No-Log-File",
      },
      {
        title: "Store Requisition",
        url: "/admin/transaction/Store-Requisition",
      },
      {
        title: "Stock Issue File",
        url: "/admin/transaction/Stock-Issue-File",
      },
      {
        title: "Local Purchase Order(LPO)",
        url: "/admin/transaction/Local-Purchase-Order(LPO)",
      },
    ],
  },
  {
    "Cashier Transactions": [
      {
        title: "Cashier Log",
        url: "/admin/transaction/Cashier-Log",
      },
      {
        title: "Session Manager",
        url: "/admin/transaction/Session-Manager",
      },
    ],
  },
  {
    "Cash Book": [
      {
        title: "Accounts",
        url: "/admin/transaction/Accounts",
      },
      {
        title: "Receipts",
        url: "/admin/transaction/Receipts",
      },
      {
        title: "Customer Payments",
        url: "/admin/transaction/Customer-Payments",
      },
      {
        title: "Suppliers Payment",
        url: "/admin/transaction/Suppliers-Payment",
      },
      {
        title: "Expenses",
        url: "/admin/transaction/Expenses",
      },
      {
        title: "Cheque Log",
        url: "/admin/transaction/Cheque-Log",
      },
      {
        title: "Cash Banking",
        url: "/admin/transaction/Cash-Banking",
      },
    ],
  },
];

export { modes };
